import { render, staticRenderFns } from "./MasterScanner.vue?vue&type=template&id=652875c9&scoped=true&"
import script from "./MasterScanner.vue?vue&type=script&lang=js&"
export * from "./MasterScanner.vue?vue&type=script&lang=js&"
import style0 from "./MasterScanner.vue?vue&type=style&index=0&id=652875c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652875c9",
  null
  
)

export default component.exports